import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { EmptyState } from '../../components/commons';
import { InvalidSearchImg } from '../../images/images';
import { Input, SearchBox, Loader, Wysiwyg } from '..';

export const Form = ({
  isLoading = false,
  data = [],
  error = null,
  isBtnDisabled = false,
  setBtnDisabled = () => {},
  handleSubmit = () => {},
}) => {
  const [formRes, setFormRes] = useState(null);
  const [bodyData, setBodyData] = useState(null);
  const form = useRef(null);

  useEffect(() => {
    modifyFormData(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const getBodyParams = (item, obj) => {
    if (Array.isArray(item.value)) {
      let ids =
        item.value &&
        item.value.map((ele) => {
          return ele.id;
        });
      obj[item.id] = ids;
    } else {
      obj[item.id] = item.value;
    }
    setBodyData(obj);
  };

  const modifyFormData = () => {
    let obj = { ...bodyData };
    if (!data) return;
    let response =
      data &&
      data.map((item) => {
        if (item.value && item.value.length) {
          item['selectedValues'] = item.value;
          getBodyParams(item, obj);
        }
        return item;
      });
    setFormRes(response);
  };

  const validateForm = () => {
    let errors = [];
    let res = formRes.map((element) => {
      const { required, selectedValues } = element;
      let nullValue =
        !selectedValues || (selectedValues && !selectedValues.length);
      if (required && nullValue) {
        element['error'] = 'This field can not be empty.';
        errors.push(element);
      }
      return element;
    });
    setFormRes(res);
    if (errors && errors.length) {
      return false;
    } else {
      return true;
    }
  };

  const onSubmit = (event) => {
    event.preventDefault();
    if (isBtnDisabled) return false;
    let isValidate = validateForm();
    if (isValidate) {
      setBtnDisabled(true);
      handleSubmit(bodyData);
    }
  };

  const onChange = (item, value) => {
    let obj = { ...bodyData };
    if (value && value.length) {
      delete item.error;
    }
    obj[item.id] = value;
    item['selectedValues'] = value;
    setBodyData(obj);
  };

  const hanldeWysiwygChange = (item, value) => {
    let obj = { ...bodyData };
    if (value && value.length) {
      delete item.error;
    }
    obj[item.id] = value;
    item['selectedValues'] = value;
    setBodyData(obj);
  };

  const onSelect = (item, selectedValues = []) => {
    let obj = { ...bodyData };
    if (selectedValues && selectedValues.length) {
      delete item.error;
    }
    obj[item.id] = selectedValues;
    item['selectedValues'] = selectedValues;
    setBodyData(obj);
  };

  if (isLoading) {
    return <Loader />;
  }

  if (error || (formRes && !formRes.length)) {
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading={
          (error && error.message) ||
          'Something went wrong. Please try again later.'
        }
      />
    );
  }

  if (formRes && formRes.length) {
    return (
      <Form.Wrapper>
        <Form.Container onSubmit={onSubmit} ref={form}>
          <Form.Inputs>
            {formRes.map((item, index) => {
              let dropdownOptions = null,
                addedTags = null;
              if (item.type === 'select') {
                dropdownOptions =
                  item.options &&
                  item.options.map((ele) => {
                    ele['title'] = ele.name;
                    return ele;
                  });
              }

              if (item.isMultiSelect && item.value && item.value.length) {
                addedTags = item.value.map((ele) => {
                  ele['title'] = ele.name;
                  return ele;
                });
              }

              return (
                <div key={index} className='col mb20 pb10'>
                  <label>
                    <span className='mb10 flex labelTitle semiBold'>
                      {item.label}:
                      {item.required && <span className='red huge'>*</span>}
                    </span>
                  </label>
                  {['text', 'email', 'password', 'integer'].includes(
                    item.type,
                  ) && (
                    <Input
                      name={item.label}
                      value={item.value || ''}
                      type={item.type}
                      onChange={onChange.bind(this, item)}
                      showMaxLimit={false}
                      disabled={item.disabled}
                      required={item.required}
                      errorText={item.error}
                      error={item.error}
                    />
                  )}
                  {['text-area'].includes(item.type) && (
                    <Wysiwyg
                      value={item.value || ''}
                      error={item.error}
                      onChange={hanldeWysiwygChange.bind(this, item)}
                    />
                  )}
                  {['select'].includes(item.type) && (
                    <SearchBox
                      result={dropdownOptions}
                      addedTags={addedTags}
                      value={item.value}
                      onSelect={onSelect.bind(this, item)}
                      autoFocus={false}
                      placeholder={`Select ${item.label}...`}
                      menuHeight='10rem'
                      isMultiSelect={item.isMultiSelect}
                      error={item.error}
                    />
                  )}
                </div>
              );
            })}
          </Form.Inputs>
          <Form.SubmitBtn
            type='submit'
            value='Submit'
            disabled={isBtnDisabled}
          ></Form.SubmitBtn>
        </Form.Container>
      </Form.Wrapper>
    );
  }
  return null;
};

Form.Wrapper = styled.div`
  position: relative;
  flex: 1;
  overflow: auto;
  height: 85vh;
`;

Form.Container = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
Form.Inputs = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10rem;
`;

Form.SubmitBtn = styled.input`
  position: sticky;
  background: ${(props) => (props.disabled ? '#D6D6D6' : '#3AB757')};
  border: none;
  color: #fff;
  padding: 1rem;
  width: 100%;
  border-radius: 0.4rem;
  bottom: 0;
  right: 0;
  left: 0;
  cursor: pointer;
  z-index: 150;
`;
